// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tenant-admin-unassign-customer-user-parent-container{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.45);
    font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}
.tenant-admin-unassign-customer-user-container{
    padding: 10px 25px;
    border-radius: 5px;
    box-sizing: border-box;
    background-color: white;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
}
.tenant-admin-unassign-customer-user-container h1{
    margin: 20px 0px;
    font-size: 20px;
    font-weight: 600;
}
.tenant-admin-unassign-customer-user-container p{
    margin: 20px 0px;
    color: rgb(114, 114, 114);
}
.tenant-admin-unassign-customer-user-container .buttons-container{
    text-align: right;
    padding-top: 16px;
    box-sizing: border-box;
}
.tenant-admin-unassign-customer-user-container .buttons-container button{
    border: none;
    margin-left: 5px;
    cursor: pointer;
    border-radius: 4px;
    padding: 10px 24px;
    font-weight: 600;
    font-size: 14px;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    color: rgba(155, 30, 30, 0.952);
    background-color: transparent;
    transition: color 0.25s ease-in,background-color 0.25s ease-in;
}
.tenant-admin-unassign-customer-user-container .buttons-container button:hover{
    background-color: rgba(245, 245, 245, 0.952);
}`, "",{"version":3,"sources":["webpack://./src/styles/workspace_styles/TenantAdministratorStyles/Customers/CustomerUsers/UnassignCustomerUser.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qCAAqC;IACrC,4DAA4D;AAChE;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,sCAAsC;AAC1C;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,yBAAyB;AAC7B;AACA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,sBAAsB;AAC1B;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,4DAA4D;IAC5D,+BAA+B;IAC/B,6BAA6B;IAC7B,8DAA8D;AAClE;AACA;IACI,4CAA4C;AAChD","sourcesContent":[".tenant-admin-unassign-customer-user-parent-container{\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 10;\n    width: 100vw;\n    height: 100vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: rgba(0, 0, 0, 0.45);\n    font-family: \"Segoe UI\", Tahoma, Geneva, Verdana, sans-serif;\n}\n.tenant-admin-unassign-customer-user-container{\n    padding: 10px 25px;\n    border-radius: 5px;\n    box-sizing: border-box;\n    background-color: white;\n    box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);\n}\n.tenant-admin-unassign-customer-user-container h1{\n    margin: 20px 0px;\n    font-size: 20px;\n    font-weight: 600;\n}\n.tenant-admin-unassign-customer-user-container p{\n    margin: 20px 0px;\n    color: rgb(114, 114, 114);\n}\n.tenant-admin-unassign-customer-user-container .buttons-container{\n    text-align: right;\n    padding-top: 16px;\n    box-sizing: border-box;\n}\n.tenant-admin-unassign-customer-user-container .buttons-container button{\n    border: none;\n    margin-left: 5px;\n    cursor: pointer;\n    border-radius: 4px;\n    padding: 10px 24px;\n    font-weight: 600;\n    font-size: 14px;\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    color: rgba(155, 30, 30, 0.952);\n    background-color: transparent;\n    transition: color 0.25s ease-in,background-color 0.25s ease-in;\n}\n.tenant-admin-unassign-customer-user-container .buttons-container button:hover{\n    background-color: rgba(245, 245, 245, 0.952);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
